export const NAMESPACE = 'RoundLeg';
export const LOAD_ROUNDLEG = 'RoundLeg/LOAD_ROUNDLEG';
export const LOAD_ROUNDLEGS = 'RoundLeg/LOAD_ROUNDLEGS';
